import Image from 'next/image';
import React from 'react';
import { PasswordInputWithToggleStyle } from '../../../styles/components/common/ui';
import FormLayout from '../layout/FormLayout';

interface InputProps {
  name: string;
  id: string;
  placeholder?: string;
  value?: string;
  label?: string | React.ReactNode;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  error?: string;
  defaultValue?: string;
  wrapper?: boolean;
  styles?: any;
  children?: React.ReactNode;
  ref?: any;
  autoFocus?: boolean;
  className?: string;
}

const PasswordInputWithToggle = ({
  styles,
  name,
  id,
  placeholder,
  value,
  onChange,
  onBlur,
  disabled = false,
  error,
  defaultValue,
  label,
  children,
  wrapper,
  ref,
  autoFocus,
  className,
}: InputProps) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <FormLayout
        styles={styles}
        error={error}
        label={children ? children : label}>
        <div
          className={
            PasswordInputWithToggleStyle['password-input-with-toggle']
          }>
          <input
            ref={ref}
            type={showPassword ? 'text' : 'password'}
            name={name}
            id={id}
            style={
              error
                ? {
                    ...styles,
                    backgroundColor: '#FEF1F2',
                    borderColor: '#E18E96',
                  }
                : { ...styles }
            }
            className={className}
            placeholder={placeholder}
            value={value}
            disabled={disabled}
            onChange={onChange}
            onBlur={onBlur}
            defaultValue={defaultValue}
            autoFocus={autoFocus}
          />
          <span
            className={
              PasswordInputWithToggleStyle['password-input-with-toggle-button']
            }
            onClick={togglePassword}>
            <Image
              quality={90}
              src={
                showPassword
                  ? '/assets/images/icons/HidePasswordIcon.svg'
                  : '/assets/images/icons/ShowPasswordIcon.svg'
              }
              width={24}
              height={24}
              alt={'Password toggle'}
            />
          </span>
        </div>
      </FormLayout>
    </>
  );
};

export default PasswordInputWithToggle;
